"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _ = require("../..");

var _mobxReact = require("mobx-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./BalanceCard.css");

var _styles = {
  "container": "BalanceCard__container___2iLy0",
  "body-container": "BalanceCard__body-container___3m22b",
  "left-container": "BalanceCard__left-container___3CeKf",
  "right-container": "BalanceCard__right-container___1Ebs-",
  "label": "BalanceCard__label___2ZJuZ",
  "italic": "BalanceCard__italic___1gkPr",
  "italic-all-caps": "BalanceCard__italic-all-caps___m4p0D",
  "tooltip": "BalanceCard__tooltip___1FzH-",
  "ticker-prefix": "BalanceCard__ticker-prefix___2buL0"
};

const styles = _bind.default.bind(_styles);

const BalanceCard = (0, _mobxReact.observer)(({
  className,
  balance,
  balanceColored,
  balanceTicker,
  showBalanceDecimals = true,
  label,
  tooltip,
  tooltipIcon = _.IconEnum.info_circle,
  labelVariant = 'regular',
  labelSize = 15,
  rightColumnChildren,
  footer,
  dataTestId,
  bodyContainerBottomPadding = 32,
  ...props
}) => {
  const composed_classname = (0, _bind.default)(styles('container'), className);
  const [tickerColor, setTickerColor] = (0, _react.useState)(_.Color.neutral._90);
  const balanceFormatted = balance.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: showBalanceDecimals ? 2 : 0,
    maximumFractionDigits: showBalanceDecimals ? 2 : 0
  }).replace('$', '');
  (0, _react.useEffect)(() => {
    if (balance === 0 || !balanceColored) {
      setTickerColor(_.Color.neutral._90);
    } else if (balance > 0) {
      setTickerColor(_.Color.green._80);
    } else {
      setTickerColor(_.Color.semantic.$error50);
    }
  }, [balance]);
  return _react.default.createElement(_.Card, {
    className: composed_classname,
    dataTestId: dataTestId,
    ...props
  }, _react.default.createElement("div", {
    className: styles('body-container')
  }, _react.default.createElement("div", {
    className: styles('left-container'),
    style: {
      paddingBottom: bodyContainerBottomPadding
    }
  }, _react.default.createElement(_.Text, {
    className: styles('label', labelVariant),
    size: labelSize,
    variant: labelVariant,
    color: _.Color.neutral._80,
    tag: tooltip ? 'span' : 'p'
  }, label, "\u00A0", tooltip && _react.default.createElement(_.Tooltip, {
    className: styles('tooltip'),
    text: tooltip,
    position: 'top',
    dataTestId: dataTestId && `${dataTestId}-tooltip`
  }, _react.default.createElement(_.Icon, {
    name: tooltipIcon,
    size: 20,
    color: _.Color.neutral._80,
    className: styles('tooltip-icon')
  }))), balanceTicker ? _react.default.createElement(_.NumberTicker, {
    dataTestId: dataTestId && `${dataTestId}-number-ticker`,
    value: balance,
    color: tickerColor,
    size: 40,
    fontVariant: 'medium',
    prefixClassName: styles('ticker-prefix'),
    variant: 'currency',
    showDecimals: showBalanceDecimals
  }) : _react.default.createElement(_.Dollar, {
    dataTestId: dataTestId && `${dataTestId}-dollar`,
    value: balanceFormatted,
    variant: 'medium',
    tag: 'h2',
    color: tickerColor
  })), rightColumnChildren && _react.default.createElement("div", {
    style: {
      paddingBottom: bodyContainerBottomPadding
    },
    className: styles('right-container')
  }, rightColumnChildren)), footer);
});
var _default = BalanceCard;
exports.default = _default;